import { useMemo } from 'react';
import { UserExperienceMemberState, useUserExperience } from './useUserExperience';

export const useOnboardingMembers = () => {
  const { data: userExperience } = useUserExperience();

  const onboardingMembers = useMemo(() => {
    return userExperience?.members.filter((m) => m.state == UserExperienceMemberState.Onboarding) || [];
  }, [userExperience?.members]);

  return onboardingMembers;
};
